import { __decorate } from 'tslib';
import { NgModule } from '@angular/core';
import { faFacebookF, faTwitter, faLinkedinIn, faPinterestP, faRedditAlien, faTumblr, faWhatsapp, faVk, faFacebookMessenger, faTelegramPlane, faMix, faXing, faLine } from '@fortawesome/free-brands-svg-icons';
import { faSms, faEnvelope, faCheck, faPrint, faExclamation, faLink, faEllipsisH, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fortawesome/angular-fontawesome';
const shareIcons = [
    faFacebookF, faTwitter, faLinkedinIn, faPinterestP, faRedditAlien, faTumblr,
    faWhatsapp, faVk, faFacebookMessenger, faTelegramPlane, faMix, faXing, faSms,
    faEnvelope, faCheck, faPrint, faExclamation, faLink, faEllipsisH, faMinus, faLine
];
let ShareIconsModule = class ShareIconsModule {
    constructor(iconLibrary) {
        iconLibrary.addIcons(...shareIcons);
    }
};
ShareIconsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ShareIconsModule });
ShareIconsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ShareIconsModule_Factory(t) { return new (t || ShareIconsModule)(ɵngcc0.ɵɵinject(ɵngcc1.FaIconLibrary)); }, imports: [[
            FontAwesomeModule,
        ]] });
ShareIconsModule.ctorParameters = () => [
    { type: FaIconLibrary }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ShareIconsModule, { imports: function () { return [FontAwesomeModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ShareIconsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FontAwesomeModule,
                ]
            }]
    }], function () { return [{ type: ɵngcc1.FaIconLibrary }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { ShareIconsModule };

//# sourceMappingURL=ngx-sharebuttons-icons.js.map